var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("loading-overlay is-" + _vm.backgroundType)},[_c('ProgressCircular',{attrs:{"is-center":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }